/**
 * PLI-2031 — Módulo singleton para almacenar el JWT del delivery_person en memoria.
 *
 * El JWT del repartidor NO se guarda en localStorage (sesión efímera).
 * Este módulo actúa como store en memoria para que el interceptor de
 * axiosInstance pueda leer el token como fallback.
 */

let deliveryPersonJwt: string | null = null;
let deliveryCommerceId: string | null = null;

export const setDeliveryPersonJwt = (jwt: string | null) => {
  deliveryPersonJwt = jwt;
};

export const getDeliveryPersonJwt = (): string | null => {
  return deliveryPersonJwt;
};

export const setDeliveryCommerceId = (commerceId: string | null) => {
  deliveryCommerceId = commerceId;
};

export const getDeliveryCommerceId = (): string | null => {
  return deliveryCommerceId;
};

export const clearDeliveryPersonSession = () => {
  deliveryPersonJwt = null;
  deliveryCommerceId = null;
};
